import { getIsQuizOpen } from '@bridebook/web/lib/quiz/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';

const BeautyQuizLazy = lazyComponent(() => import('./beauty-quiz'));

const BeautyQuiz = () => {
  const isQuizOpen = useSelector(getIsQuizOpen('hairAndBeauty'));

  if (!isQuizOpen) {
    return null;
  }

  return <BeautyQuizLazy />;
};

export default BeautyQuiz;
